import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-pop-up',
    templateUrl: './pop-up.component.html',
    styleUrls: ['./pop-up.component.scss']
})
export class PopUpComponent {
    @Input() type: 'approve' | 'reject' = 'approve';
    @Input() title = '';
    @Input() isProcessing = false;
    @Input() selectedRejectionOption = '';
    @Input() rejectionReason = '';
    @Input() customRemark = '';

    @Output() confirm = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();
    @Output() reasonSelect = new EventEmitter<string>();
    @Output() customReasonInput = new EventEmitter<string>();

    onReasonSelect(event: any) {
        if (!event || !event.target) return;
        const value = event.target.value;

        this.reasonSelect.emit(value);
    }

    onCustomReasonInput(event: any) {
        if (!event || !event.target) return;

        const value = event.target.value;
        this.customReasonInput.emit(value);
    }

    onConfirm() {
        console.log('onConfirm called');
        console.log('Current state:', {
            type: this.type,
            selectedRejectionOption: this.selectedRejectionOption,
            rejectionReason: this.rejectionReason,
            customRemark: this.customRemark
        });

        this.confirm.emit();
    }

    onCancel() {
        this.cancel.emit();
    }
}
